module.exports = __webpack_public_path__ + "img/show_icon.e14d439a.png";